import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { IonicModule } from '@ionic/angular'

import { CreateEditUsersPageRoutingModule } from './create-edit-users-routing.module'

import { CreateEditUsersPage } from './create-edit-users.page'
import { ComponentsModule } from 'src/app/components/components.module'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatSelectModule } from '@angular/material/select'
import { PasswordModule } from 'primeng/password'
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion'
import { ListboxModule } from 'primeng/listbox'
import { SelectButtonModule } from 'primeng/selectbutton'
import { CheckboxModule } from 'primeng/checkbox'
import { InputTextModule } from 'primeng/inputtext'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatSelectModule,
    PasswordModule,
    ListboxModule,
    ComponentsModule,
    SelectButtonModule,
    CheckboxModule,
    IonicModule,
    CreateEditUsersPageRoutingModule,
    InputTextModule,
  ],
  declarations: [CreateEditUsersPage],
})
export class CreateEditUsersPageModule {}
